import {
  IBudget,
  ICompetitor,
  ICoupons,
  IPagination,
  IState,
  IUserData,
} from "./interfaces";

export default {
  getBudget(state: IState): IBudget {
    return state.budget;
  },
  getCompetitor(state: IState): ICompetitor {
    return state.competitor;
  },

  getPaginate(state: IState): IPagination {
    return state.paginate;
  },

  getExistCoupon(state: IState): boolean {
    return state.existCoupon;
  },

  getCouponsList(state: IState): ICoupons {
    return state.coupons;
  },

  getCodeCoupon(state: IState): string {
    return state.codeCoupon;
  },

  getTypesCoupon(state: IState): string[] {
    return state.typesCoupon
  },

  getListCompetitor(state: IState): string[] {
    return state.listCompetitor
  },

  getPercentage(state: IState): number {
    return state.percentage
  },

  getUserInfo(state: IState): IUserData {
    return state.userData
  },
};
